import { render, staticRenderFns } from "./StaticChart.vue?vue&type=template&id=fa91b3c2&scoped=true&"
import script from "./StaticChart.vue?vue&type=script&lang=js&"
export * from "./StaticChart.vue?vue&type=script&lang=js&"
import style0 from "./StaticChart.vue?vue&type=style&index=0&id=fa91b3c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa91b3c2",
  null
  
)

export default component.exports